import { createAction } from 'redux-actions';
export var submitStatus = createAction('STATUS.SUBMIT', function (payload) { return payload; });
export var submitStatusFailure = createAction('STATUS.SUBMIT.FAILURE', function (payload) { return payload; });
export var submitStatusFailureDismiss = createAction('STATUS.SUBMIT.FAILURE.DISMISS', function () { return ({}); });
export var submitStatusSuccess = createAction('STATUS.SUBMIT.SUCCESS', function (payload) { return payload; });
export var deleteStatus = createAction('STATUS.DELETE', function (payload) { return payload; });
//# sourceMappingURL=actions.js.map